import { useEffect, useState } from "react";
import { authFetch } from "../../../api";
import ConfimationPopup from "../../../STMPages/components/customPopup/ConfimationPopup";
import GlobalDeleteModal from "../Modal/GlobalDeleteModal";
import { DeleteIcon } from "lucide-react";
import VisaUploadSection from "./VisaUploadSection";

export default function TravelHistoryTab({
  formData,
  setFormData,
  handleInputChange,
  errors = {},
  countryList,
  travelHistoryList,
  setTravelHistoryList,
  handleEditTravel,
  showAddForm,
  setShowAddForm,
  handleDelete,
  visaUploadStatus,
  setVisaUploadStatus,
  travelHistoryDeleted,
}) {
  const userId = localStorage.getItem("userId");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [visaTypes, setVisaTypes] = useState([]);
  const [travelStatusList, setTravelStatusList] = useState([]);
  const [visaStatusList, setVisaStatusList] = useState([]);
  const [skipUpload, setSkipUpload] = useState(true);

  const fetchTravelHistory = async () => {
    try {
      const response = await authFetch("application/show-all-travel-history", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await response.json();
      setTravelHistoryList(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchVisaStatus = async () => {
    try {
      const response = await authFetch("visa/get-all-visa-status", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      setVisaStatusList(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTravelStatus = async () => {
    try {
      const response = await authFetch("visa/get-all-travel-status", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      setTravelStatusList(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchVisaTypes = async () => {
    try {
      const response = await authFetch("visa/get-all-visa-types", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      setVisaTypes(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchTravelHistory();
    fetchVisaTypes();
    fetchTravelStatus();
    fetchVisaStatus();
  }, []);

  const getVisaTypeName = (id) =>
    visaTypes.find((v) => v.id === Number(id))?.type_name || "—";

  const getTravelStatusName = (id) =>
    travelStatusList.find((s) => s.id === Number(id))?.status || "—";

  const getVisaStatusName = (id) =>
    visaStatusList.find((s) => s.id === Number(id))?.status || "—";

  const isRejected =
    visaStatusList.find((v) => v.id === Number(formData.visaStatus))?.status ===
    "Reject";

  return (
    <div className="space-y-4">
      {showDeleteModal && (
        <ConfimationPopup
          handleClose={() => setShowDeleteModal(false)}
          open={showDeleteModal}
          component={
            <GlobalDeleteModal
              text="Delete Details ?"
              subText="Are you sure you want to delete your Travel History Details?"
              buttonTitle="Delete"
              startIcon={<DeleteIcon />}
              open={showDeleteModal}
              onClose={() => {
                setShowDeleteModal(false);
              }}
              onConfirm={() => {
                handleDelete(deleteIndex);
                setShowDeleteModal(false);
              }}
            />
          }
        />
      )}
      <div className="flex justify-between mt-2">
        {/* Main Header */}
        <div className="text-md font-altisunisa text-black flex items-center gap-2 mb-2">
          <img className="h-8 w-8" src="/travel.png" alt="travel" />
          Travel History
        </div>
        {travelHistoryList.length === 0 && (
          <button
            onClick={() => {
              if (skipUpload) {
                // Skip upload
                setVisaUploadStatus("skipped");
              } else {
                // Go back to upload
                setVisaUploadStatus("pending");
              }
              setSkipUpload((prev) => !prev);
            }}
            className="px-4 py-2 bg-white text-[#572575] border border-[#572575] rounded-lg text-sm font-semibold"
          >
            {skipUpload ? "Skip Upload" : "Upload Visa"}
          </button>
        )}

        {/* ADD / LIST AREA */}
        {travelHistoryList.length > 0 && (
          <div className={`${formData.hasTravelled === "no" ? "hidden" : ""}`}>
            <button
              onClick={() => {
                setShowAddForm((prev) => {
                  const next = !prev;

                  // When OPENING add form → skip upload
                  if (next) {
                    setVisaUploadStatus("skipped");
                  }
                  // When CLOSING add form → go back to list state
                  else {
                    setVisaUploadStatus("pending");
                  }

                  return next;
                });
              }}
              className="px-4 py-2 bg-[#572575] text-white rounded-lg text-sm"
            >
              {showAddForm ? "Close" : "Add Travel Entry"}
            </button>
          </div>
        )}
      </div>

      {/* Show Deleted work history ONLY if user deleted all */}
      {travelHistoryDeleted &&
        travelHistoryList.length === 0 &&
        formData.hasWorked === "yes" && (
          <div className="w-full bg-white border rounded-xl p-6 flex flex-col items-center justify-center text-center space-y-3">
            <img src="/NoWorkHistory.png" alt="no-work" className="h-24 w-24" />

            <h2 className="font-inter text-xl font-semibold text-black">
              No Travel History saved Yet
            </h2>

            <p className="font-inter text-gray-600 max-w-md">
              Your previous travel history have been removed. You can add them
              again to continue your application.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
            >
              Add Travel History
            </button>
          </div>
        )}

      {/* ADD TRAVEL HISTORY FORM */}
      {!travelHistoryDeleted &&
        (travelHistoryList.length === 0 || showAddForm) && (
          <div>
            {/* Have you travelled before? */}
            {!travelHistoryDeleted &&
              travelHistoryList.length === 0 &&
              !showAddForm && (
                <div className="">
                  <label className="block mb-2 font-medium text-black font-semibold">
                    Have you travelled internationally before?
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-6 items-center p-2">
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="hasTravelled"
                        value="yes"
                        checked={formData.hasTravelled === "yes"}
                        onChange={handleInputChange}
                      />
                      Yes
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="hasTravelled"
                        value="no"
                        checked={formData.hasTravelled === "no"}
                        onChange={handleInputChange}
                      />
                      No
                    </label>
                  </div>
                </div>
              )}
            {errors.hasTravelled && (
              <p className="text-red-500 text-sm">{errors.hasTravelled}</p>
            )}

            {/* FORM (shows when user says "yes" OR when adding/editing) */}
            {(formData.hasTravelled === "yes" || showAddForm) &&
              visaUploadStatus !== "pending" && (
                <div className="grid grid-cols-2 gap-6 bg-white p-4 border rounded-xl">
                  {/* Travel status */}
                  <div>
                    <label className="block mb-1 text-black">
                      Travel status <span className="text-red-500">*</span>
                    </label>

                    <select
                      name="travelStatus"
                      value={formData.travelStatus}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.travelStatus ? "border-red-500" : ""
                      }`}
                    >
                      <option value="">Select status</option>

                      {travelStatusList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.status}
                        </option>
                      ))}
                    </select>

                    {errors.travelStatus && (
                      <p className="text-red-500 text-sm">
                        {errors.travelStatus}
                      </p>
                    )}
                  </div>

                  {/* Country */}
                  <div>
                    <label className="block mb-1 text-black">
                      Choose Country <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="travelCountry"
                      value={formData.travelCountry}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.travelCountry ? "border-red-500" : ""
                      }`}
                    >
                      <option value="">Select Country</option>
                      <option value="Test">TEST</option>
                      {countryList?.map((item) => (
                        <option key={item.id} value={item.country_name}>
                          {item.country_name}
                        </option>
                      ))}
                    </select>
                    {errors.travelCountry && (
                      <p className="text-red-500 text-sm">
                        {errors.travelCountry}
                      </p>
                    )}
                  </div>

                  {/* Type of Visa */}
                  <div>
                    <label className="block mb-1 text-black">
                      Type of Visa <span className="text-red-500">*</span>
                    </label>

                    <select
                      name="visaType"
                      value={formData.visaType}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.visaType ? "border-red-500" : ""
                      }`}
                    >
                      <option value="">Select visa type</option>

                      {visaTypes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.type_name}
                        </option>
                      ))}
                    </select>

                    {errors.visaType && (
                      <p className="text-red-500 text-sm">{errors.visaType}</p>
                    )}
                  </div>

                  {/* Visa Status */}
                  <div>
                    <label className="block mb-1 text-black">
                      Visa status <span className="text-red-500">*</span>
                    </label>

                    <select
                      name="visaStatus"
                      value={formData.visaStatus}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.visaStatus ? "border-red-500" : ""
                      }`}
                    >
                      <option value="">Select visa status</option>

                      {visaStatusList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.status}
                        </option>
                      ))}
                    </select>

                    {errors.visaStatus && (
                      <p className="text-red-500 text-sm">
                        {errors.visaStatus}
                      </p>
                    )}
                  </div>

                  {/* Date of Issue */}
                  <div>
                    <label className="block mb-1 text-black">
                      Date of Issue <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="issueDate"
                      value={formData.issueDate}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.issueDate ? "border-red-500" : ""
                      }`}
                    />
                    {errors.issueDate && (
                      <p className="text-red-500 text-sm">{errors.issueDate}</p>
                    )}
                  </div>

                  {/* Expiry Date */}
                  <div>
                    <label className="block mb-1 text-black">Expiry Date</label>
                    <input
                      type="date"
                      name="expiryDate2"
                      value={formData.expiryDate2}
                      onChange={handleInputChange}
                      className={`border w-full p-2 rounded-lg ${
                        errors.expiryDate2 ? "border-red-500" : ""
                      }`}
                    />
                  </div>

                  {/* Date of Rejection (ONLY IF REJECTED) */}
                  {isRejected && (
                    <>
                      <div>
                        <label className="block mb-1 text-black">
                          Date of Rejection{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          name="rejectionDate"
                          value={formData.rejectionDate}
                          onChange={handleInputChange}
                          className={`border w-full p-2 rounded-lg ${
                            errors.rejectionDate ? "border-red-500" : ""
                          }`}
                        />
                        {errors.rejectionDate && (
                          <p className="text-red-500 text-sm">
                            {errors.rejectionDate}
                          </p>
                        )}
                      </div>

                      {/* Reason */}
                      <div>
                        <label className="block mb-1 text-black">
                          Reason for Rejection{" "}
                          <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          name="rejectionReason"
                          value={formData.rejectionReason}
                          onChange={handleInputChange}
                          placeholder="Enter reason for rejection"
                          className={`border w-full p-2 rounded-lg ${
                            errors.rejectionReason ? "border-red-500" : ""
                          }`}
                        />

                        {errors.rejectionReason && (
                          <p className="text-red-500 text-sm">
                            {errors.rejectionReason}
                          </p>
                        )}
                      </div>

                      {/* Proof Available */}
                      <div>
                        <label className="block mb-1 text-black">
                          Proof Available{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="flex gap-6 items-center">
                          <label className="flex items-center gap-2">
                            <input
                              type="radio"
                              name="rejectionProof"
                              value="yes"
                              checked={formData.rejectionProof === "yes"}
                              onChange={handleInputChange}
                            />
                            Yes
                          </label>

                          <label className="flex items-center gap-2">
                            <input
                              type="radio"
                              name="rejectionProof"
                              value="no"
                              checked={formData.rejectionProof === "no"}
                              onChange={handleInputChange}
                            />
                            No
                          </label>
                        </div>
                      </div>

                      {/* Upload Document */}
                      {formData.rejectionProof === "yes" && (
                        <div>
                          <label className="block mb-1 text-black">
                            Upload Document
                          </label>
                          <input
                            type="file"
                            name="travelDocument"
                            onChange={handleInputChange}
                            className="border w-full p-2 rounded-lg"
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
          </div>
        )}

      {/* UPLOAD */}
      {formData.hasTravelled === "yes" &&
        visaUploadStatus === "pending" &&
        travelHistoryList.length === 0 && <VisaUploadSection />}

      {/* NEW QUESTION (Always visible regardless of first question) */}
      {formData.hasTravelled === "no" && (
        <>
          <label className="block mb-2 font-medium text-black font-semibold">
            Have you ever applied for a visa before?{" "}
            <span className="text-red-500">*</span>
          </label>

          <div className="flex gap-6 items-center mb-4">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="hasAppliedVisa"
                value="yes"
                checked={formData.hasAppliedVisa === "yes"}
                onChange={handleInputChange}
              />
              Yes
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="hasAppliedVisa"
                value="no"
                checked={formData.hasAppliedVisa === "no"}
                onChange={handleInputChange}
              />
              No
            </label>
          </div>
        </>
      )}

      {/* IF USER SAYS YES TO VISA APPLICATION */}
      {formData.hasTravelled === "no" && formData.hasAppliedVisa === "yes" && (
        <div className="grid grid-cols-2 gap-6 bg-white p-4 border rounded-xl">
          {/* Type of Visa */}
          <div>
            <label className="block mb-1 text-black">
              Type of Visa <span className="text-red-500">*</span>
            </label>
            <select
              name="visaType"
              value={formData.visaType}
              onChange={handleInputChange}
              className="border w-full p-2 rounded-lg"
            >
              <option value="">Select Visa Type</option>
              <option value="Tourist">Tourist Visa</option>
              <option value="Student">Student Visa</option>
              <option value="Work">Work Visa</option>
            </select>
          </div>

          {/* Visa Status */}
          <div>
            <label className="block mb-1 text-black">
              Visa Status <span className="text-red-500">*</span>
            </label>
            <select
              name="visaStatus"
              value={formData.visaStatus}
              onChange={handleInputChange}
              className="border w-full p-2 rounded-lg"
            >
              <option value="">Select Status</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          {/* Date of Issue */}
          <div>
            <label className="block mb-1 text-black">
              Date of Issue <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="issueDate"
              value={formData.issueDate}
              onChange={handleInputChange}
              className="border w-full p-2 rounded-lg"
            />
          </div>

          {/* Expiry Date */}
          <div>
            <label className="block mb-1 text-black">Expiry Date</label>
            <input
              type="date"
              name="expiryDate2"
              value={formData.expiryDate2}
              onChange={handleInputChange}
              className="border w-full p-2 rounded-lg"
            />
          </div>

          {/* SHOW REJECTION FIELDS ONLY IF VISA STATUS = REJECTED */}
          {isRejected && (
            <>
              <div>
                <label className="block mb-1 text-black">
                  Date of Rejection <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="rejectionDate"
                  value={formData.rejectionDate}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                />
              </div>

              <div>
                <label className="block mb-1 text-black">
                  Reason of Rejection <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="rejectionReason"
                  value={formData.rejectionReason}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                />
              </div>
            </>
          )}
        </div>
      )}

      {/* IF USER SELECTS NO FOR VISA + NO FOR TRAVEL */}
      {formData.hasTravelled === "no" && formData.hasAppliedVisa === "no" && (
        <div className="mt-4">
          <label className="block mb-2 font-medium text-black">
            Select your tentative dates for applying{" "}
            <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            name="travelTentativeDate"
            value={formData.travelTentativeDate || ""}
            onChange={handleInputChange}
            className="border w-full p-2 rounded-lg"
          />
        </div>
      )}

      {/* LIST */}
      {formData.hasTravelled === "yes" && !showAddForm && (
        <div className="space-y-4 mt-4">
          {travelHistoryList.length === 0 ? (
            <p className="text-sm text-gray-500">
              No travel entries added yet.
            </p>
          ) : (
            travelHistoryList.map((t, index) => (
              <div
                key={index}
                className="bg-[#FFF6FB] border border-[#F3D9EA] rounded-xl p-6"
              >
                {/* Title + Actions */}
                <div className="flex justify-between items-center mb-6">
                  {/* Status Title */}
                  <h2 className="text-lg font-semibold text-black">
                    {getTravelStatusName(t.travel_status)} (Travel Status)
                  </h2>

                  <div className="flex gap-4 text-sm ">
                    <button
                      onClick={() => handleEditTravel(index)}
                      className="text-[#177BE5] text-sm font-semibold hover:underline"
                    >
                      ✎ Edit
                    </button>

                    <button
                      onClick={() => {
                        setDeleteIndex(index);
                        setShowDeleteModal(true);
                      }}
                      className="text-[#D20000] text-sm font-semibold hover:underline"
                    >
                      🗑 Delete
                    </button>
                  </div>
                </div>

                {/* Columns */}
                <div className="grid grid-cols-2 gap-2">
                  {/* Country */}
                  <div>
                    <p className="text-sm text-gray-600 mb-1">
                      Choose Country <span className="text-red-600">*</span>
                    </p>
                    <div
                      className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-semibold text-black"
                      style={{ borderColor: "#F3D9EA" }}
                    >
                      {t.travel_country_name || "—"}
                    </div>
                  </div>

                  {/* Type of Visa */}
                  <div>
                    <p className="text-sm text-gray-600 mb-1">
                      Type of Visa <span className="text-red-600">*</span>
                    </p>
                    <div
                      className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-semibold text-black"
                      style={{ borderColor: "#F3D9EA" }}
                    >
                      {getVisaTypeName(t.types_of_visa)}
                    </div>
                  </div>

                  {/* Visa Status */}
                  <div>
                    <p className="text-sm text-gray-600 mb-1">
                      Visa Status <span className="text-red-600">*</span>
                    </p>
                    <div
                      className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-semibold text-black"
                      style={{ borderColor: "#F3D9EA" }}
                    >
                      {getVisaStatusName(t.visa_status)}
                    </div>
                  </div>

                  {/* Date Of Issue */}
                  <div>
                    <p className="text-sm text-gray-600 mb-1">
                      Date of Issue <span className="text-red-600">*</span>
                    </p>
                    <div
                      className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-semibold text-black"
                      style={{ borderColor: "#F3D9EA" }}
                    >
                      {t.date_of_issue
                        ? new Date(t.date_of_issue).toLocaleDateString("en-GB")
                        : "—"}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
